// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hC","loading":"hD","b":"hE","errorMsg":"hF","loadingMsg":"hG","successMsg":"hH","hideLoadingMsg":"hI","completed":"hJ","a":"hK"};